<template>
  <div
    class="search_container"
    :class="[
      { expand: (!isResult || focusOnInput) && !isHomepage },
      { home: isHomepage },
      { result: isResult },
    ]"
  >
    <div class="top_section">
      <div class="search_input">
        <form action="javascript:">
          <v-text-field
            id="search"
            class="search_field"
            type="search"
            color="gray"
            placeholder="請輸入關鍵字查詢"
            @keyup.enter="search(keyword.trim())"
            solo
            flat
            clearable
            :maxlength="20"
            v-model="keyword"
            @focus="focusOnInput = true"
          >
            <template v-slot:prepend-inner>
              <img src="@/assets/img/icon/MenuSearch.svg" />
            </template>
          </v-text-field>
        </form>
      </div>
      <div v-if="isHomepage" class="btns">
        <div @click="toTicket" class="icon ticket">
          <img src="@/assets/img/ticket.svg" />
        </div>
        <div @click="toService" class="icon service">
          <img src="@/assets/img/service.svg" />
        </div>
      </div>
      <div v-else-if="(!isResult || focusOnInput) && !isHomepage">
        <button @click="backTo" class="cancel_button">取消</button>
      </div>
    </div>
    <div
      class="wrap"
      v-if="!isHomepage && (focusOnInput || !isResult)"
      :class="{ expand: !isResult || focusOnInput }"
    >
      <div v-if="hotWords.length" class="mid_section">
        <h3>熱門搜尋</h3>
        <div class="tag_box">
          <button
            v-for="(word, index) in hotWords"
            :key="'word' + index"
            class="tag"
            @click="search(word)"
          >
            {{ word }}
          </button>
        </div>
      </div>
      <div class="divider"></div>
      <div class="btm_section">
        <div class="title">
          <h3>搜尋紀錄</h3>
          <div class="clear" @click="clearHistory">清除紀錄</div>
        </div>
        <ul>
          <li class="history_tag null" v-if="!historyList.length">
            尚無查詢記錄
          </li>
          <li
            v-for="(history, index) in historyList"
            :key="'history' + index"
            class="history_tag"
            @click="search(history)"
          >
            <div class="history_title">{{ history }}</div>
            <div class="arrow">
              <img src="@/assets/img/icon/left_top_arrow.svg" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isResult: {
      type: Boolean,
      default: false,
    },
    isHomepage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      focusOnInput: false,
      keyword: '',
      hotWords: [],
      historyList: [],
    }
  },
  async created() {
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
    if (!this.isHomepage) {
      api
        .getHotSearchProduct()
        .then(res => {
          this.hotWords = res.data
        })
        .catch(function(err) {
          console.log('getHotSearchProduct fail')
          console.log(err)
        })
      this.getSearchlog()
    }
  },
  methods: {
    ga(keyword) {
      gtag('event', 'search', {
        event_category: 'search',
        event_label: '查詢關鍵字',
        location: this.$route.name == 'home' ? '首頁' : '搜尋頁',
        keyword: keyword,
        search_term: keyword,
      })
    },
    async getSearchlog() {
      api
        .getUserProductSearchLogs()
        .then(res => {
          this.historyList = res.data
        })
        .catch(function(err) {
          console.log('getUserProductSearchLogs fail')
          console.log(err)
        })
    },
    async search(keyword) {
      if (keyword === '') return
      this.ga(keyword)
      if (this.isResult) {
        this.keyword = keyword
        if (keyword !== this.$route.query.keyword) {
          this.$router.replace({
            query: { keyword },
          })
        }
        this.focusOnInput = false
      } else {
        this.$router.push({
          name: 'searchResult',
          query: { keyword },
        })
      }
    },
    async clearHistory() {
      api
        .deleteProductSearchLog()
        .then(res => {
          this.historyList = []
        })
        .catch(err => {
          this.$bus.$emit('callAllert', {
            messageContent: '刪除失敗，請再試一次' + '(' + err + ')',
          })
          console.log(err)
        })
    },
    backTo() {
      if (this.isResult) {
        this.focusOnInput = false
        if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
      } else {
        this.$router.back()
      }
    },
    toTicket() {
      this.$router.push({ name: 'orderListTicket' })
    },
    toService() {
      this.$router.push({ name: 'customerServicePage' })
    },
  },
}
</script>

<style lang="scss" scoped>
.search_container {
  height: auto;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 12;
  padding-bottom: 49px;
  &.expand {
    height: 100%;
  }
  &.home {
    position: fixed;
    z-index: 999;
    padding-bottom: 0px;
  }
}
button:focus {
  outline: 0;
}
.top_section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 48px;
  width: 100%;
  padding: 20px 4.8% 9px;
  ::v-deep .search_input {
    flex-grow: 1;
    min-width: 79.1%;
    width: auto;
    #search {
      font-size: 14px;
    }
    .search_field {
      margin-top: 0;
      padding-top: 0;
      .v-input__control {
        min-height: auto;
      }
      &.v-text-field .v-input__control .v-input__slot {
        margin-bottom: 0;
        border-radius: 10px;
        background-color: #f0f2f5;
        min-height: auto;
      }
      .v-text-field__details {
        display: none;
      }
      .v-input__prepend-inner {
        width: 18px;
        height: 16px;
        margin-right: 8px;
        img {
          width: 140%;
        }
      }
      .v-input__icon.v-input__icon--clear {
        .v-icon--link {
          min-width: 16px;
          height: 16px;
          background-color: #bcbcbc;
          color: #fff;
          font-size: 12px;
          border-radius: 50%;
          &.primary--text {
            color: #fff !important;
          }
        }
      }
    }
  }
  .cancel_button {
    margin-left: 16px;
    white-space: nowrap;
    font-size: 16px;
    padding: 0 12px;
  }
}
.home {
  .top_section {
    height: 75px;
    padding: 20px 4.8%;
    .search_input {
      min-width: 64.8%;
    }
  }
  .btns {
    display: flex;
    .icon {
      width: 28px;
      height: 28px;
      margin-left: 20px;
      img {
        width: 100%;
      }
    }
  }
}
.result {
  .top_section {
    height: 65px;
    padding: 20px 4.8% 10px;
  }
}
h3 {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: bold;
}
.mid_section {
  padding: 16px 4.3%;
  .tag_box {
    width: 103%;
    margin-left: -4px;
  }
  .tag {
    max-width: 49%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    font-size: 15px;
    color: #4a4a4a;
    line-height: 1.47;
    background-color: #f0f2f5;
    padding: 4px 12px;
    margin: 8px 4px;
    border-radius: 15px;
    border-color: transparent;
  }
}

.divider {
  width: 100%;
  height: 8px;
  background-color: #f7f7f7;
}
.btm_section {
  padding: 16px 4.3% 27px;
  .title {
    display: flex;
    justify-content: space-between;
  }
  .clear {
    font-size: 13px;
    cursor: pointer;
    color: #1da7fc;
    font-weight: normal;
  }
  ul {
    padding: 0;
  }
  .history_tag {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #6d7278;
    list-style: none;
    width: 100%;
    cursor: pointer;
    padding: 12px 0px 14px 0px;
    position: relative;
    box-shadow: inset 0 -1px 0 0 #ebebeb;
    .history_title {
      max-width: 95%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .arrow {
      width: 12px;
      height: 12px;
      transform: scaleX(-1);
      filter: opacity(0.6);
      font-size: 0;
      img {
        width: 100%;
      }
    }
  }
}

.wrap {
  overflow-x: hidden;
  overflow-y: scroll;
  overflow: hidden scroll;
  height: 0;
  &.expand {
    height: 100%;
    background-color: #fff;
    padding-top: 48px;
    padding-bottom: 49px;
  }
}
</style>
